<ion-header [translucent]="true">
  <ion-row class="ble-mode__header">
    <ion-col class="ion-no-padding">
      <div class="title-with-icon">
        <div class="back-icon" (click)="goBack()">
          <ion-img [src]="backArrow"></ion-img>
        </div>
        <div>
          {{ 'ble_mode.deviceManagement' | translate }}
        </div>
      </div>
    </ion-col>
    <ion-col class="ion-no-padding">
      <ion-row class="ble-mode__actions ion-align-items-center">
        <ion-label class="bt-heading">{{ 'ble_mode.bluetooth' | translate }}</ion-label>
        <ion-toggle
          class="bluetooth-toggle"
          [(ngModel)]="bleService.hasBluetoothEnabled"
          [disabled]="bleService.hasBluetoothEnabled"
          (ionChange)="turnOnBluetoothAndLocation($event)"
          >{{ 'ble_mode.bluetooth' | translate }}</ion-toggle
        >
        <div class="separator"></div>
        <ui-custom-button
          [btnTxt]="'ble_mode.scanDevices' | translate"
          [buttonType]="'PRIMARY'"
          [isDisabled]="!bleService.hasBluetoothEnabled"
          (clickEvent)="scanDevices()"
        ></ui-custom-button>
      </ion-row>
    </ion-col>
  </ion-row>
</ion-header>

<ion-content [fullscreen]="true">
  <div class="ble-mode__content">
    <div class="rfid-vendor-block" *ngIf="deviceManagementProps.showOnlyRfidOptions || useRfidScanMode">
      <div class="title">{{ 'ble_mode.RFID' | translate }}</div>
      <div class="connected-device-title" *ngIf="connectedVendor">{{ 'ble_mode.CONNECTED_DEVICE' | translate }}</div>
      <div *ngFor="let vendor of allAvailableRfidVendors" class="vendor-block">
        <div class="vendor-details">
          <div
            class="connected-icon"
            [ngStyle]="{ backgroundColor: connectedVendor === vendor ? '#0d8525' : 'lightgray' }"
          ></div>
          <div class="vendor-name">{{ vendorToDisplayNameMap[vendor] | translate }}</div>
        </div>
        <div class="connection-buttons">
          <ng-container *ngIf="connectedVendor === vendor">
            <ui-custom-button
              [btnTxt]="'ble_mode.updateReadPower' | translate"
              [buttonType]="'TERITIARY'"
              [buttonHeight]="'45px'"
              (clickEvent)="openUpdateReadpowerModal()"
            ></ui-custom-button>
            <ui-custom-button
              [btnTxt]="'ble_mode.disconnect' | translate"
              [buttonType]="'PRIMARY'"
              [buttonWidth]="'140px'"
              [buttonHeight]="'45px'"
              (clickEvent)="handleDisconnectVendorBasedRfid()"
            ></ui-custom-button>
          </ng-container>

          <ui-custom-button
            *ngIf="connectedVendor !== vendor"
            [btnTxt]="'ble_mode.connect' | translate"
            [buttonType]="'TERITIARY'"
            [buttonWidth]="'140px'"
            [buttonHeight]="'45px'"
            [isDisabled]="!!connectedVendor || !!connectedNFCDevice"
            (clickEvent)="handleConnectToVendorRfid(vendor)"
          ></ui-custom-button>
        </div>
      </div>
    </div>

    <div class="rfid-vendor-block" *ngIf="isNFCEnabled || deviceManagementProps.showNfcConnectionOption">
      <div class="title">{{ 'ble_mode.nfcDevice' | translate }}</div>
      <div class="vendor-block">
        <div class="vendor-details">
          <div
            class="connected-icon"
            [ngStyle]="{ backgroundColor: connectedNFCDevice ? '#0d8525' : 'lightgray' }"
          ></div>
          <div class="vendor-name">{{ 'ble_mode.nfc' | translate}}</div>
        </div>
        <ui-custom-button
          *ngIf="!connectedNFCDevice; else nfcDisconnectButton"
          [btnTxt]="'ble_mode.connect' | translate"
          [buttonType]="'TERITIARY'"
          [buttonWidth]="'140px'"
          [buttonHeight]="'45px'"
          [isDisabled]="!!connectedVendor"
          (clickEvent)="handleConnectToNfc()"
        ></ui-custom-button>
        <ng-template #nfcDisconnectButton>
          <ui-custom-button
            [btnTxt]="'ble_mode.disconnect' | translate"
            [buttonType]="'PRIMARY'"
            [buttonWidth]="'140px'"
            [buttonHeight]="'45px'"
            (clickEvent)="handleDisconnectNfc()"
          ></ui-custom-button>
        </ng-template>
      </div>
    </div>

    <div class="ble-mode-block" *ngIf="allowZebraBleConnection">
      <div class="title">{{ 'ble_mode.bleModeDevices' | translate }}</div>
      <div class="device-block">
        <div class="device-name">{{ 'ble_mode.zebraBarcodeScanner' | translate}}</div>
        <ui-custom-button
          *ngIf="!isZebraBleDeviceConnected; else zebraDisconnectButton"
          [btnTxt]="'ble_mode.connect' | translate"
          [buttonType]="'TERITIARY'"
          [buttonWidth]="'140px'"
          [buttonHeight]="'45px'"
          [isDisabled]="!bleService.hasBluetoothEnabled"
          (clickEvent)="connectToZebraDeviceUsingBleMode()"
        ></ui-custom-button>
        <ng-template #zebraDisconnectButton>
          <ui-custom-button
            [btnTxt]="'ble_mode.disconnect' | translate"
            [buttonType]="'PRIMARY'"
            [buttonWidth]="'140px'"
            [buttonHeight]="'45px'"
            (clickEvent)="disconnectZebraBleModeDevice()"
          ></ui-custom-button>
        </ng-template>
      </div>
    </div>

    <!-- We only need RFID options (if showOnlyRfidOptions is true, in case of ba-app - barcode scanner is not needed) -->
    <div *ngIf="!deviceManagementProps.showOnlyRfidOptions" class="paired-devices-block">
      <div class="title">{{ 'ble_mode.pairedDevices' | translate }}</div>
      <ng-container *ngFor="let device of bleService.pairedDevices">
        <div class="device-block">
          <div class="device-name">
            {{ device.device.name }}
          </div>
          <div class="connection-buttons">
            <ui-custom-button
              *ngIf="
                bleService.connectedDevice && bleService.connectedDevice.deviceId === device.device.deviceId;
                else deviceConnectButton
              "
              [btnTxt]="'ble_mode.disconnect' | translate"
              [buttonType]="'PRIMARY'"
              [buttonWidth]="'140px'"
              [buttonHeight]="'45px'"
              (clickEvent)="disconnectToDevice(device.device)"
            ></ui-custom-button>
            <ng-template #deviceConnectButton>
              <ui-custom-button
                [btnTxt]="'ble_mode.connect' | translate"
                [buttonType]="'TERITIARY'"
                [buttonWidth]="'140px'"
                [buttonHeight]="'45px'"
                [isDisabled]="
                  (!!bleService.connectedDevice && bleService.connectedDevice.deviceId !== device.device.deviceId) ||
                  !bleService.hasBluetoothEnabled
                "
                (clickEvent)="connectToDevice(device.device)"
              ></ui-custom-button>
            </ng-template>
            <div class="unpair-device-container">
              <ion-img src="assets/common/delete-icon.svg" (click)="unpairDevice(device.device)"></ion-img>
            </div>
          </div>
        </div>
      </ng-container>
      <div class="no-devices" *ngIf="bleService.pairedDevices.length === 0">
        {{ 'ble_mode.noPairedDevices' | translate }}
      </div>
    </div>

    <!-- We only need RFID options (if showOnlyRfidOptions is true, in case of ba-app - barcode scanner is not needed) -->
    <div *ngIf="!deviceManagementProps.showOnlyRfidOptions" class="available-devices-block">
      <div class="title">{{ 'ble_mode.availableDevices' | translate }}</div>
      <ng-container *ngFor="let device of bleService.availableDevices">
        <div class="device-block">
          <div class="device-name">
            {{ device.name }}
          </div>
          <ui-custom-button
            [btnTxt]="'ble_mode.connect' | translate"
            [buttonType]="'TERITIARY'"
            [buttonWidth]="'140px'"
            [buttonHeight]="'45px'"
            [isDisabled]="!!bleService.connectedDevice"
            (clickEvent)="connectToDevice(device)"
          ></ui-custom-button>
        </div>
      </ng-container>
      <div class="no-devices" *ngIf="bleService.availableDevices.length === 0">
        {{ 'ble_mode.noAvailableDevices' | translate }}
      </div>
    </div>
  </div>
</ion-content>
